module.exports = __webpack_public_path__ + "static/media/az.e22a7542.svg";